<script lang="ts" setup>
import { useMyPreviewMode } from '@autobid/ui/composables/useMyPreviewMode'
import { PAGES_COLLECTIONS } from '@autobid/ui/constants/PAGES_COLLECTIONS'
import { PREVIEW_STATUSES } from '@autobid/ui/constants/PREVIEW_STATUSES'

const TARGETS_COLLECTIONS = {
  page: PAGES_COLLECTIONS,
  slide: ['slides'],
  article: ['articles'],
  popup: ['popups'],
  pdf: ['pdfs'],
}

const TARGETS = {
  page: defineAsyncComponent(() => import('./Page.vue')),
  popup: defineAsyncComponent(() => import('./Popup.vue')),
  article: defineAsyncComponent(() => import('./Article.vue')),
  pdf: defineAsyncComponent(() => import('./Pdf.vue')),
  slide: defineAsyncComponent(() => import('./Slide.vue')),
}

const { enabled, state } = useMyPreviewMode()
const target = computed(() => {
  return Object.entries(TARGETS_COLLECTIONS).find(([_, collections]) => {
    return collections.find(el => el === state.collection)
  })?.[0] as keyof typeof TARGETS | undefined
})
</script>

<template>
  <div class="w-full">
    <div
      v-if="!enabled"
      class="container mx-auto px-3 py-10"
    >
      {{ $t('page-preview.preview-mode-not-available') }}
    </div>

    <div
      v-else-if="!target"
      class="container mx-auto px-3 py-10"
    >
      {{ $t('page-preview.unable-to-find-target', { collection: state.collection }) }}
    </div>

    <div
      v-else-if="!PREVIEW_STATUSES.includes(state.status)"
      class="container mx-auto px-3 py-10"
    >
      {{ $t('page-preview.unsupported-status') }} ({{ state.status }})
      <p class="whitespace-pre-line">
        Supported: {{ PREVIEW_STATUSES.join(', ') }}
      </p>
    </div>

    <div
      v-else
      class="bg-white"
    >
      <component :is="TARGETS[target]" />

      <p
        class="fixed bottom-2 left-2 z-20 rounded-md bg-primary px-2 py-1 text-sm text-white"
      >
        {{ $t('page-preview.draft') }}
      </p>
    </div>
  </div>
</template>
